import { DataType } from '@app/components/table-list-grid/data-type';
import { Action } from '@ntap/core';
import { TableMeta } from '@ntap/primeng';

const ACTION_BAR_HIDE_LIST_ACTION = [
  'openJedinicaGradiva',
  'openAgent',
  'openArhivPosjednik'
];
type DataTypeKey = { [key in DataType]?: string };
const TABLE_LIST_GRID_DATA_BY_TYPES: { [viewName: string]: DataTypeKey } = {
  jedinica_gradiva: {
    title: 'en~jedinica_gradiva~glavni_naziv',
    label: 'en~jedinica_gradiva~arhivska_oznaka',
    level: 'en~jedinica_gradiva~razina',
    created: 'en~jedinica_gradiva~vrijeme_nastanka_labela',
    owner: 'en~jedinica_gradiva~posjednik_naziv',
    'superior-item': 'en~jedinica_gradiva~nadredena_jedinica_labela',
    content: 'en~jedinica_gradiva~sadrzaj',
    licence: 'en~jedinica_gradiva~licenca',
    quantity: 'en~jedinica_gradiva~kolicina',
    'content-type': 'en~jedinica_gradiva~vrsta_sadrzaja',
    'hierarchy-label': 'en~jedinica_gradiva~nalazi_se_u_labela'
  },
  moje_gradivo: {
    title: 'en~jedinica_gradiva~glavni_naziv',
    label: 'en~jedinica_gradiva~arhivska_oznaka',
    level: 'en~jedinica_gradiva~razina',
    created: 'en~jedinica_gradiva~vrijeme_nastanka_godina',
    owner: 'en~jedinica_gradiva~posjednik_naziv',
    'superior-item': 'en~jedinica_gradiva~nadredena_jedinica_labela',
    content: 'en~jedinica_gradiva~sadrzaj',
    licence: 'en~jedinica_gradiva~licenca'
  },
  agent: {
    title: 'en~agent~naziv',
    identifier: 'en~agent~glavni_identifikator',
    'agent-type': 'en~agent~vrsta_agenta',
    'owner-type': 'en~agent~oblik_vlasnistva',
    status: 'en~agent~status',
    history: 'en~agent~povijest',
    timespan: 'en~agent~vrijeme_djelovanja_labela'
  },
  registar_arhiva_i_posjednika: {
    title: 'en~agent~naziv',
    label: 'en~arhiv_posjednik~oznaka',
    identifier: 'en~arhiv_posjednik~identifikator_upisa',
    'owner-type': 'en~arhiv_posjednik~tip_posjednika',
    'archive-owner': 'en~arhiv_posjednik~nadlezni_arhiv',
    status: 'en~arhiv_posjednik~status',
    history: 'en~agent~povijest',
    headquarters: 'en~arhiv_posjednik~sjediste_labela',
    hours: 'en~arhiv_posjednik~radno_vrijeme',
    webpage: 'en~agent~mrezna_stranica'
  }
};

export class TableListGridUtil {
  public static isFirstActionListVisible(action: Action): boolean {
    return ACTION_BAR_HIDE_LIST_ACTION.indexOf(action.name) === -1;
  }

  public static getColumnByDataType(
    meta: TableMeta,
    type: DataType
  ): string | undefined {
    const tableConfig = TABLE_LIST_GRID_DATA_BY_TYPES[meta.viewName];
    return tableConfig[type];
  }
}
